import { render, staticRenderFns } from "./imageeditor.vue?vue&type=template&id=3c874386&"
import script from "./imageeditor.vue?vue&type=script&lang=js&"
export * from "./imageeditor.vue?vue&type=script&lang=js&"
import style0 from "./imageeditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports